import FloatLabelInput from '@src/main/shared/ui/components/input/FloatLabelInput';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AddressForm.module.scss';

interface AddressFormProps {
  values: {
    email: string;
    description: string;
  };
  handleChange: (field: keyof AddressFormProps['values'], value: string) => void;
  errors?: Record<string, string>;
}

const AddressForm: FC<AddressFormProps> = ({ values, handleChange, errors }) => {
  const { t } = useTranslation();

  return (
    <form>
      <div className={styles.grid}>
        <FloatLabelInput
          label={t('messages.addresses.description')}
          value={values.description}
          onChange={(val) => handleChange('description', val)}
          error={errors?.description}
          className={`${styles.field} col-12`}
          inputClassName={styles.inputfield}
        />

        <FloatLabelInput
          label={t('messages.addresses.email')}
          value={values.email}
          onChange={(val) => handleChange('email', val)}
          error={errors?.email}
          className={`${styles.field} col-12`}
          inputClassName={styles.inputfield}
        />
      </div>
    </form>
  );
};

export default AddressForm;
